export * from "./engine.debugging.pure";

import { RegisterWebGPUDebugging } from "./engine.debugging.pure";
RegisterWebGPUDebugging();
